import React, { useEffect, useState } from 'react';
import { config } from '../CommonUtils/CommonURLS';
import { CommonAxiosGet } from '../CommonUtils/CommonAxios';
import CommonReactTable from '../CommonUtils/CommonReactTable';
import { FaEdit, FaUserPlus } from 'react-icons/fa';
import { Navigate, useNavigate } from 'react-router-dom';

const S = {
    emptyState: { padding: '64px 20px', textAlign: 'center' },
};

export default function NonTeachingFaculty() {
    const [nonTeachingEmp, setNonTeachingEmp] = useState([]);
    const navigate = useNavigate();

    function getNonTeachingEmpList() {
        CommonAxiosGet(`${config.url.FAC_URL}getUniversityEmployeesnonteaching`).then((res) => {
            setNonTeachingEmp(res?.data?.scode === '01' ? res.data.data || [] : []);
        });
    }

    
    useEffect(() => {
        getNonTeachingEmpList();
    }, []);

    const columns = [
        {
            id: 'slNo',
            header: 'Sl.No',
            cell: ({ row }) => row.index + 1,
        },
        {
            id: 'cfms_id',
            header: 'CFMS Id',
            accessorKey: 'cfms_id',
            meta: { style: { textAlign: 'center' } },
        },
        {
            id: 'emp_full_name',
            header: 'Employee Name',
            accessorKey: 'emp_full_name',
        },
        // {
        //     id: 'father_name',
        //     header: 'Father Name',
        //     accessorKey: 'father_name',
        // },
        // {
        //     id: 'spouse_name',
        //     header: 'Spouse Name',
        //     accessorKey: 'spouse_name',
        // },
        // {
        //     id: 'dob',
        //     header: 'DOB',
        //     accessorKey: 'dob',
        // },
        // {
        //     id: 'doj',
        //     header: 'DOJ',
        //     accessorKey: 'doj',
        // },
        {
            id: 'mobile',
            header: 'Mobile No',
            accessorKey: 'mobile',
        },
        {
            id: 'masked_aadhar',
            header: 'Aadhaar No',
            accessorKey: 'masked_aadhar',
        },
        // {
        //     id: 'pan',
        //     header: 'PAN',
        //     accessorKey: 'pan',
        // },
        {
            id: 'qualification',
            header: 'Qualification',
            accessorKey: 'qualification',
        },
        {
            id: 'post_desc',
            header: 'Designation',
            accessorKey: 'post_desc',
        },
        {
            id: 'nature_of_post_name',
            header: 'Post',
            accessorKey: 'nature_of_post_name',
        },
        // {
        //     id: 'basicpay',
        //     header: 'Basic Pay',
        //     accessorKey: 'basicpay',
        //     cell: ({ row }) => row.original.basicpay || '-',
        // },
        // {
        //     id: 'payscale_level',
        //     header: 'Pay Level',
        //     accessorKey: 'payscale_level',
        //     cell: ({ row }) => row.original.payscale_level || '-',
        // },
        // {
        //     id: 'payscale_group',
        //     header: 'Pay Group',
        //     accessorKey: 'payscale_group',
        //     cell: ({ row }) => row.original.payscale_group || '-',
        // },
        // {
        //     id: 'payscale_type',
        //     header: 'Pay Type',
        //     accessorKey: 'payscale_type',
        //     cell: ({ row }) => row.original.payscale_type || '-',
        // },
        // {
        //     id: 'ddocode',
        //     header: 'DDO Code',
        //     accessorKey: 'ddocode',
        //     cell: ({ row }) => row.original.ddocode || '-',
        // },
        {
            id: 'description_long',
            header: 'University',
            accessorKey: 'description_long',
            cell: ({ row }) => row.original.description_long || '-',
        },
        // {
        //     id: 'description_long_1',
        //     header: 'Treasury',
        //     accessorKey: 'description_long_1',
        //     cell: ({ row }) => row.original.description_long_1 || '-',
        // },
        // {
        //     id: 'distname',
        //     header: 'District',
        //     accessorKey: 'distname',
        //     cell: ({ row }) => row.original.distname || '-',
        // },
        // {
        //     id: 'aishe_code',
        //     header: 'AISHE Code',
        //     accessorKey: 'aishe_code',
        //     cell: ({ row }) => row.original.aishe_code || '-',
        // },
        {
            id: 'actions',
            header: 'Edit',
            cell: ({ row }) => (
                <button type='button' className='btn btn-sm btn-primary'
                    onClick={() => navigate('/NonTeachingFacultyEdit', { state: { facultyData: row.original } })}
                >
                    <FaEdit size={13} />
                </button>
            ),
        },
    ];

    
    return (
        <div className='faculty-card'>
            <div className='fac-topbar'>
                <div className='fac-detnew'>
                    <h5 className='mb-0'>Non-Teaching Faculty Report</h5>
                </div>


                 <button
    className="newfacbtn"
    // onClick={() => navigate("/NonTeachingFacultyEdit")}
     onClick={() =>
        navigate("/NonTeachingFacultyEdit", {
            state: { mode: "add" }
        })
    }
>
    <FaUserPlus size={15} />
    <span>Add New Faculty</span>
</button>
            </div>

            {nonTeachingEmp.length > 0 ? (
                <CommonReactTable
                    data={nonTeachingEmp}
                    columns={columns}
                    headerName='Non-Teaching Faculty List'
                    showFooter={false}
                    showPagination={true}
                    showExcel={true}
                    showPrint={true}
                    excelFileName='Non_Teaching_Faculty_List'
                />
            ) : (
                <div style={{ padding: '64px 20px', textAlign: 'center' }}>
                    <div style={{ fontSize: '42px', marginBottom: '12px', opacity: 0.3 }}>📋</div>
                    <p style={{ fontWeight: '700', color: '#c0392b', margin: 0, fontSize: '15px' }}>No Data Found</p>
                    <p style={{ color: '#bbb', fontSize: '13px', marginTop: '6px' }}>
                        Non-teaching records are not available right now.
                    </p>
                </div>
            )
            }
        </div >
    );
}
